import angular from 'angular';

angular.module('folkeuni').directive('fileDataModel', ['$parse', function ($parse) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var model = $parse(attrs.fileDataModel);
            var modelSetter = model.assign;

            scope.$watch(attrs['fileDataModel'], function (v) {
                if(v === null || v === undefined) {
                    element[0].value = null;
                }
              });

            element.bind('change', function () {
                scope.$apply(function () {
                    modelSetter(scope, element[0].files[0]);
                });
            });
        }
    };
}]);

angular.module('folkeuni').directive('filesDataModel', ['$parse', function ($parse) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var model = $parse(attrs.filesDataModel);
            var modelSetter = model.assign;

            scope.$watch(attrs['filesDataModel'], function (v) {
                if(v === null || v === undefined) {
                    element[0].value = null;
                }
              });

            element.bind('change', function () {
                scope.$apply(function () {
                    modelSetter(scope, element[0].files);
                });
            });
        }
    };
}]);
